export function openInBackground(url?: string) {
  if (!url) return

  const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.platform)

  const a = document.createElement('a')
  a.href = url
  a.target = '_blank'
  a.rel = 'noopener noreferrer'
  a.style.display = 'none'
  document.body.appendChild(a)

  const evt = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
    ctrlKey: !isMac,
    metaKey: isMac
  })

  a.dispatchEvent(evt)
  a.remove()

  try {
    window.focus()
  } catch {
    openInBackgroundFallback(url)
  }
}

export function openInBackgroundFallback(url: string) {
  const win = window.open(url, '_blank', 'noopener,noreferrer')
  if (win) {
    try {
      win.blur()
    } catch {}
    try {
      window.focus()
    } catch {}
  }
}
